import { atom } from "jotai";
import { atomWithStorage } from 'jotai/utils';
import z from "zod";


export const BasketSchema = z.object({
  basketId: z.string(),
  totalPrice: z.number(),
  totalProduct: z.number(),
  status: z.number(),
  createdOn: z.string(),
  modifiedOn: z.string(),
  basketItemList: z.array(z.object({
    basketItemId: z.string(),
    product: z.object({
      id: z.string(),
      name: z.string(),
      image: z.string(),
      price: z.number(),
    }),
    type: z.number(),
    count: z.number(),
    totalPrice: z.number(),
    discountPrice: z.number(),
    isGift: z.boolean(),
  })),
});

export type BasketSchema = z.infer<typeof BasketSchema>;

export const BasketIdAtom = atomWithStorage<string>("basketId", "");
export const BasketAtom = atom<BasketSchema | null>(null);